import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface SettingEntry {
  key: string;
  value: string;
}

/**
 * Flags UX persistés dans le store clé/valeur boutique (`GET /settings`) :
 * `product_tour_done`, `setup_checklist_dismissed`… Partagés entre appareils,
 * avec un miroir localStorage géré par les consommateurs.
 */
export function useShopSettingFlags(enabled = true) {
  return useQuery({
    queryKey: ['settings', 'ux-flags'],
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async () => {
      const response = await api.get<SettingEntry[]>('/settings');
      const entries = Array.isArray(response.data) ? response.data : [];
      const flags: Record<string, string> = {};
      for (const entry of entries) {
        flags[entry.key] = entry.value;
      }
      return flags;
    },
  });
}
